import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import staticData from "../assests/staticData.json";
import ServiceList from "../components/Common/ServiceList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function DailyLivingSupport() {
  const { daily_living_support_service } = staticData;
  const { service_desc, service_desc_list, service_desc_bottom } =
    daily_living_support_service;

  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={daily_living_support_service.service_title}
      />
      <section className="services-layout-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={9}>
              <CRow className="align-items-center">
                <CCol lg={12}>
                  <div className="service-detail-wrapper">
                    <img
                      src={require(`../assests/${daily_living_support_service.service_image}`)}
                      alt={daily_living_support_service.service_title}
                      className="mb-4 img-fluid w-100 rounded-4"
                      style={{ height: "550px", objectFit: "cover" }}
                    />
                  </div>
                </CCol>
                <CCol lg={12}>
                  <div className="service-detail-wrapper">
                    <h1>{daily_living_support_service.service_title}</h1>
                    {service_desc.map((desc, index) => (
                      <p key={index} className="themeGrayPara in-fs lh-28 mt-2">
                        {desc}
                      </p>
                    ))}

                    {service_desc_list.map((list, index) => (
                      
                        <div className="service-desc-list-box" key={index}>
                          <div className="service-desc-icon">
                            <span>
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          </div>
                          <div>
                            <p
                              key={index}
                              className="themeGrayPara in-fs lh-28 mb-2"
                            >
                              <b style={{ color: "#0b3d2c" }}>{list?.title}</b>{" "}
                              : {list?.title_desc}
                            </p>
                          </div>
                        </div>
                      
                    ))}

                    {service_desc_bottom.map((desc, index) => (
                      <p key={index} className="themeGrayPara in-fs lh-28 mt-2">
                        {desc}
                      </p>
                    ))}
                  </div>
                </CCol>
              </CRow>
            </CCol>
            <CCol lg={3}>
              <div className="service-list-wrapper">
                <ServiceList />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
